import {
    MenuItem,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { TrackingAction, TrackingActionCategory } from '@acp/shared';
import { addTrackingEvent } from '../../../../../hooks/use-tracking-event';
import { useQuote } from '../../../../quote/hooks/use-quotes';
import { ReportedFindingsMachineContext } from '../machine/context';
// Review Quote Button Component
// This component is basically a hyperlink that redirects the user to a specific quote URL.
export function ReviewQuoteButton({
    quotationId,
}: {
    quotationId: number;
}) {
    const machine = ReportedFindingsMachineContext.useActorRef();
    const compliancePropertyId = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.compliancePropertyId
    );

    const { data } = useQuote(quotationId);
    if (data?.approvalUrl == null) {
        return null;
    }
    const handleReviewQuote = () => {
        addTrackingEvent({
            category: TrackingActionCategory.ReportedFindingsWizard,
            action: TrackingAction.ReportedFindingsWizardViewQuote,
            context: {
                quotationId,
                compliancePropertyId,
            },
        });
        machine.send({ type: 'CLOSE_MODAL' });
    };

    return (
        <MenuItem
            as={RouterLink}
            target="_blank"
            to={data.approvalUrl}
            onClick={handleReviewQuote}
        >
            Review quote
        </MenuItem>
    );
}
